// 


import React from "react";

function TextCard({ title, desc , post_author ,post_date,className}) {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
  return (
    <div style={{borderBottom:"1px solid #eaeaea",padding: ".5rem 0", ...(className === 'quick-textcard' && { paddingTop: '0px' }),
      ...(className === 'article-textcard' && { paddingTop: '0px' })}}>
      <h2 className="fw-bold h5 hoverHead">{title}</h2>

      <p className="mt-1" style={{ fontSize: "12px" }}>
      By <span className="fw-bold">{post_author}</span> | {new Date(post_date).toLocaleDateString(undefined, options) }   
      </p>
      <p className="just-text line-clamp  mt-1" style={{ fontSize: "15px" }}>
        {desc}
      </p>
     
    </div>
  );
}

export default React.memo(TextCard);
